<script setup lang="ts">
import type { StructureResource } from "@carnet/api/backoffice";

const props = defineProps<{
  structure: StructureResource;
  opensOnMap?: boolean;
}>();

const emit = defineEmits<{
  select: [];
}>();

const { t } = useI18n();

const websiteUrl = computed(() => safeExternalHttpUrl(props.structure.contact_web));
</script>

<template>
  <article class="@container/tile group/tile relative flex items-start flex-row in-[.group\/popup]:flex-col justify-between gap-4">
    <div class="min-w-0 in-[.group\/sheet]:flex-1">
      <header class="flex flex-col gap-1 not-last:mb-4">
        <h3 class="text-xl @xs/tile:text-2xl font-semibold wrap-break-words">
          {{ structure.name }}
        </h3>
        <p v-if="structure.address">{{ structure.address }}</p>
      </header>

      <ul v-if="structure.contact_phone || websiteUrl" class="relative z-1 w-fit">
        <li v-if="structure.contact_phone">
          <ULink :href="`tel:${structure.contact_phone}`">{{ structure.contact_phone }}</ULink>
        </li>
        <li v-if="websiteUrl">
          <UButton variant="link" trailing-icon="icon:external" :to="websiteUrl" target="_blank" rel="noopener noreferrer">
            {{ $t("structure.website.open") }}
          </UButton>
        </li>
      </ul>

      <div v-if="structure.type.label" class="mt-6">
        <UBadge color="primary" variant="soft" size="sm">
          {{ structure.type.label }}
        </UBadge>
      </div>
    </div>

    <AppTileButton
      v-if="opensOnMap"
      :aria-label="t('structure.tile.showOnMap', { name: structure.name })"
      icon="icon:marker"
      @click="() => emit('select')"
    />
  </article>
</template>
